const SCRIPT_ID = 'ga4-gtag-script'
const INLINE_ID = 'ga4-gtag-inline'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

export function isValidGaId(value?: string | null): value is string {
  const id = (value || '').trim()
  return /^G-[A-Z0-9]+$/i.test(id)
}

export function initGoogleAnalytics(measurementId: string) {
  if (typeof window === 'undefined' || !isValidGaId(measurementId)) return
  if (document.getElementById(SCRIPT_ID)) return

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args)
  }
  window.gtag('js', new Date())
  window.gtag('config', measurementId, {
    send_page_view: false,
    anonymize_ip: true,
  })

  const inline = document.createElement('script')
  inline.id = INLINE_ID
  inline.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}`
  document.head.appendChild(inline)

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  document.head.appendChild(script)
}

export function trackGaPageView(measurementId: string, path: string, title?: string) {
  if (typeof window === 'undefined' || !window.gtag || !isValidGaId(measurementId)) return
  if (path.startsWith('/admin')) return

  window.gtag('event', 'page_view', {
    page_title: title || document.title || 'CARLOS FELIPE',
    page_location: window.location.href,
    page_path: path,
    send_to: measurementId,
  })
}

export function trackGaEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.gtag) return
  window.gtag('event', name, params || {})
}
